var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"bubbly-button",attrs:{"to":"/donate","tag":"button"}},[_vm._v("Donate")])}
var staticRenderFns = []

export { render, staticRenderFns }